import FilePreviewPage from './FilePreviewPage'
export default FilePreviewPage
